import React from "react";
import { FormattedMessage } from "react-intl";
import { margins } from "style";
import { useProfile } from "hooks";
import PropTypes from "prop-types";
import { Header } from "components/DisplayBox";
import { CandidateAssignmentSelector } from "components/Candidate";
import { Spinner } from "components/Loader";
import { H3 } from "components/Text";

/**
 * ProfileAssignee
 *
 * @param {String}  profileId
 */
const ProfileAssignee = ({ profileId }) => {
  const { data, loading } = useProfile({ profileId });

  return (
    <>
      <Header marginSize={margins.normal}>
        <H3>
          <FormattedMessage id="Profile.ProfileAssignee.DisplayBox.Title" />
        </H3>
      </Header>
      {loading ? <Spinner size="1.5rem" /> : <CandidateAssignmentSelector profileData={data} loading={loading} />}
    </>
  );
};

ProfileAssignee.propTypes = {
  profileId: PropTypes.string.isRequired,
};

export default ProfileAssignee;
